import { useCallback, useState } from 'react';
import { logError } from '../../../../utils/logger';

export const useClipboardLink = (): {
  linkCopied: boolean;
  copyLinkToClipboard: () => Promise<void>;
} => {
  const [linkCopied, setLinkCopied] = useState(false);

  const markCopied = useCallback(() => {
    setLinkCopied(true);
    setTimeout(() => setLinkCopied(false), 2000);
  }, []);

  const copyLinkToClipboard = useCallback(async () => {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      return;
    }

    try {
      await navigator.clipboard.writeText(window.location.href);
      markCopied();
    } catch (error) {
      logError('Failed to copy link to clipboard:', error);
      const textArea = document.createElement('textarea');
      textArea.value = window.location.href;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      markCopied();
    }
  }, [markCopied]);

  return { linkCopied, copyLinkToClipboard };
};
